import type { FrontendErrorsError } from "@/features/observability/hooks/use-frontend-errors";
import type { PlatformErrorsSourceState } from "@/features/observability/platform-errors/types/platform-errors.types";

type Style = { label: string; color: string };

// Hex, not var(): recharts paints SVG attributes. Reds darken with gravity; INFO (legacy failed results) stays neutral.
const SEVERITY_STYLES = new Map<string, Style>([
    ["EMERGENCY", { label: "EMERGENCY", color: "#5C0011" }],
    ["ALERT", { label: "ALERT", color: "#9E001C" }],
    ["CRITICAL", { label: "CRITICAL", color: "#D80027" }],
    ["ERROR", { label: "ERROR", color: "#F07C2C" }],
    ["INFO", { label: "INFO", color: "#94A3B8" }],
]);

const severityStyle = (value: string | null): Style => {
    if (value === null) return { label: "—", color: "#CCCCCC" };
    const style = SEVERITY_STYLES.get(value);
    return style === undefined ? { label: value, color: "#CCCCCC" } : style;
};

// A stale answer (no fresh ingestion heartbeat) may be missing what was never ingested: its counts are a floor too.
const isLowerBound = (state: PlatformErrorsSourceState): boolean =>
    state.sourceStatus !== "ok" || state.countsAreLowerBound || state.stale;

// The backend's 400 message when a window starts before the 13 retained days: the fix is to move the window.
const isOutsideRetention = (error: FrontendErrorsError | null): boolean =>
    error !== null && error.message === "window_outside_retention";

const OUTSIDE_RETENTION_TEXT = "El rango queda fuera de los 13 días que se conservan para la plataforma";

export const platformErrorsFormat = { severityStyle, isLowerBound, isOutsideRetention, OUTSIDE_RETENTION_TEXT };
